/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the KnownIssueDto interface.
 */
export function instanceOfKnownIssueDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined)
        return false;
    if (!('active' in value) || value['active'] === undefined)
        return false;
    return true;
}
export function KnownIssueDtoFromJSON(json) {
    return KnownIssueDtoFromJSONTyped(json, false);
}
export function KnownIssueDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'title': json['title'],
        'content': json['content'],
        'displayOrder': json['displayOrder'],
        'active': json['active'],
    };
}
export function KnownIssueDtoToJSON(json) {
    return KnownIssueDtoToJSONTyped(json, false);
}
export function KnownIssueDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
        'displayOrder': value['displayOrder'],
        'active': value['active'],
    };
}
